    import React, { Fragment, useState, useEffect } from 'react';

    import HeaderV2 from '../../components/headerV2/HeaderV2';
    import FooterV2 from '../../components/footerV2/FooterV2';
    import AboutHero from '../../components/aboutHero/AboutHero';
    import { Helmet } from 'react-helmet';

    import { fetchMagazines } from '../../api/cmsApi';

    import '../AboutUsPage/aboutV2.css';
    import './Newsletters.css';

    // import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
    // import classnames from 'classnames';


    export default function Newsletters() {

      const [activeTab, setActiveTab] = useState('magazine');
      const [selectedYear, setSelectedYear] = useState('2026');
      const [selectedInitiative, setSelectedInitiative] = useState('JJFIndia');
      const [currentPage, setCurrentPage] = useState(1);

      const [showAll, setShowAll] = useState(false);
      const [cmsMagazines, setCmsMagazines] = useState([]);
      const itemsPerPage = 12;
      const VISIBLE_COUNT = 6;

      // Newer issues are published from the CMS
      useEffect(() => {
        const controller = new AbortController();

        fetchMagazines({ signal: controller.signal })
          .then((items) => {
            if (controller.signal.aborted) return;
            setCmsMagazines(items);
          })
          .catch((error) => {
            if (controller.signal.aborted || error.name === 'AbortError') return;
            // A CMS outage must not blank out the issues already listed here
            console.error('Could not load newsletters from the CMS:', error);
          });

        return () => controller.abort();
      }, []);

      useEffect(() => {
        setCurrentPage(1);
      }, [selectedYear]);

        useEffect(() => {
          setShowAll(false);
      }, [activeTab]);

      const getVisibleItems = (items) => {
      return showAll ? items : items.slice(0, VISIBLE_COUNT);
      };

        const magazineData = {
        "2024": [
          { id: 1, title: 'September 2024 Newsletter',  url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/September+2024.pdf' },
          { id: 2, title: 'October 2024 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/October+2024.pdf' },
          { id: 3, title: 'November 2024 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/November+2024.pdf' },
          { id: 4, title: 'December 2024 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+December+2024.pdf' },
        ],
        "2025": [
          { id: 1, title: 'January 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+January+2025+(Volume+5).pdf' },
          { id: 2, title: 'February 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+February+2025+(Volume+6).pdf'},
          { id: 3, title: 'March 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+March+2025+(Volume+7).pdf'},
          { id: 4, title: 'April 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+April+2025+(Volume+8).pdf'},
          { id: 5, title: 'May 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+May+2025+(Volume+9).pdf' },
          { id: 6, title: 'June 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+June+2025+(Volume+10).pdf.pdf' },
          { id: 7, title: 'July 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+July+2025+(Volume+11).pdf.pdf' },
          { id: 8, title: 'August 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+August++2025+(Volume+12).pdf.pdf' },
          { id: 9, title: 'September 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/_JJF+Magazine+-+September+2025+(Volume+13).pdf.pdf' },
          { id: 10, title: 'October 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+October+2025+(Volume+14).pdf+(3).pdf'},
          { id: 11, title: 'November 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+November+2025+(Volume+15).pdf' },
          { id: 12, title: 'December 2025 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+December+2025+(Volume+16).pdf.pdf' },
        ],
        "2026":[
           { id: 1, title: 'January 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/jjf-magazine-january-2026-volume-17.pdf' },
           { id: 2, title: 'February 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF-Magazine-February-2026-(Volume+18).pdf.pdf' },
           { id: 3, title: 'March 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-March-2026-(Volume+-19).pdf.pdf' },
           { id: 4, title: 'April 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-April+2026+(Volume+20).pdf' },
           { id: 5, title: 'May 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-+May+2026+(Volume+21).pdf.pdf' },
           { id: 6, title: 'June 2026 Newsletter', url: 'https://jjfindia-magazine.s3.ap-south-1.amazonaws.com/JJF+Magazine+-June+2026+(Volume+22).pdf.pdf' },
        ]
      };

      // The issues listed above stay exactly as they are. Anything approved in the
      // CMS is folded in under its year, skipping titles that are already listed.
      const titleKey = (title) => String(title || '').toLowerCase().replace(/[^a-z0-9]/g, '');

      const allMagazineData = { ...magazineData };

      cmsMagazines.forEach((item) => {
        const year = String(item.year);
        const listed = allMagazineData[year] || [];

        if (listed.some(existing => titleKey(existing.title) === titleKey(item.title))) return;

        allMagazineData[year] = [
          ...listed,
          { id: `cms-${item.id}`, title: item.title, url: item.pdfUrl }
        ];
      });

      // The year dropdown follows the data, so a new CMS year appears on its own
      const availableYears = Object.keys(allMagazineData).sort();

      // Gallery Images

    const galleryImages = [
      {
        id: 1,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-9.jpg',
        title: 'Blood Donation'
      },
      {
        id: 2,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-11.jpg',
        title: 'Food Donation'
      },
      {
        id: 3,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-10.jpg',
        title: 'Blood Donation'
      },
      {
        id: 4,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-11.jpg',
        title: 'Food Donation'
      },
      {
        id: 5,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-12.jpg',
        title: 'Tree Plantation'
      },
      {
        id: 6,
        type: 'photo',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Gallary-13.jpg',
        title: 'Tree Plantation'
      },
      {
        id: 7,
        type: 'photo',
        imageUrl: process.env.PUBLIC_URL + '/images/newsletters-v2/documentary-screening.jpg',
        title: 'Documentary Screening'
      },
      {
        id: 8,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Change-Your-Life.jpg',
        title: 'Change Your Life'
      },
      {
        id: 9,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/AFM.jpg',
        title: 'AFM'
      },
      {
        id: 10,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Jain-Star-Awards.jpg',
        title: 'Jain Star Awards'
      },
        {
        id: 11,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Sandeep-StandUp-Comedian.jpg',
        title: 'Sandeep - Stand-Up Comedian'
      },
      {
        id: 12,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Indo-Global-Leader.jpg',
        title: 'Indo Global Leaders'
      },
      {
        id: 13,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Indo-Global-Leaders.jpg',
        title: 'Indo Global Leaders'
      },
      {
        id: 14,
        type: 'award',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Suryadatta-National-Awards.jpg',
        title: 'Suryadatta National Awards'
      },
      {
        id: 15,
        type: 'video',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/Dark+Modern+Elegant+Singer+New+Song+YouTube+Thumbnail+(2).jpg',
        title: 'Ek Chhota Sa Moment Jo Sab Badal Gaya',
        videoUrl: 'https://youtube.com/shorts/TwkF_0MmOLk?si=Mpq_9wCrBtYi4Zhg'
      },
      {
        id: 16,
        type: 'video',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/How+JJFIndia+really+felt+about.jpg',
        title: 'How JJFIndia Really Felt About It',
        videoUrl: 'https://youtube.com/shorts/5MN3CG7DTNE?feature=share'
      },
      {
        id: 17,
        type: 'video',
        imageUrl: 'https://jjfindia-newsletters-images.s3.ap-south-1.amazonaws.com/JJFIndia+achieves+1+lakh+volunteers.jpg',
        title: 'JJFIndia Achieves 1 Lakh Volunteers',
        videoUrl: 'https://youtube.com/shorts/IVTbP471OIc?feature=share'
      }
    ];

        // Sidebar Navigation Component
        const Sidebar = () => (
            <div className="newsletter-sidebar">
                <div className='tab-parent'>
                    { activeTab === "magazine" && (<><div className='upper-corner'></div><div className='lower-corner'></div></>)}
                    <button className={`sidebar-menu-item ${activeTab === 'magazine' ? 'active' : ''}`} onClick={() => setActiveTab('magazine')} >
                        Magazine
                    </button>
                </div>
                
                <div className='tab-parent'>
                    { activeTab === "photo" && (<><div className='upper-corner'></div><div className='lower-corner'></div></>)}
                    <button className={`sidebar-menu-item ${activeTab === 'photo' ? 'active' : ''}`} onClick={() => setActiveTab('photo')} >
                        Photo Gallery
                    </button>
                </div>
                
                <div className='tab-parent'>
                    { activeTab === "video" && (<><div className='upper-corner'></div><div className='lower-corner'></div></>)}
                    <button className={`sidebar-menu-item ${activeTab === 'video' ? 'active' : ''}`} onClick={() => setActiveTab('video')} >
                        Videos Gallery
                    </button>
                </div>

                <div className='tab-parent'>
                    { activeTab === "awards" && (<><div className='upper-corner'></div><div className='lower-corner'></div></>)}
                    <button className={`sidebar-menu-item ${activeTab === 'awards' ? 'active' : ''}`} onClick={() => setActiveTab('awards')} >
                        Awards
                    </button>
                </div>
            </div>
        );

        // Filter Bar Component
        const FilterBar = ( {showFYears} ) => (
            <div style={{width: "100%", backgroundColor: "#FFF", borderRadius: "4px"}}>
                <div className="filter-section">
                    { !showFYears && (<div className="filter-group">
                        <label className="filter-label">Initiative</label>
                        <select className="filter-select" value={selectedInitiative} onChange={(e) => setSelectedInitiative(e.target.value)} >
                            <option>JJFIndia</option>
                            <option>LifeSaverArmy</option>
                            <option>SevaArmy</option>
                            <option>MindUnload</option>
                        </select>
                    </div>)}

                    { showFYears && (<div className="filter-group">
                        <label className="filter-label">Financial Year</label>
                        <select className="filter-select" value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} >
                            {availableYears.map(year => (
                                <option key={year}>{year}</option>
                            ))}
                        </select>
                    </div>)}
                    {/* <button className="apply-btn">Apply</button> */}
                </div>
            </div>
        );

    const currentYearData = allMagazineData[selectedYear] || [];

    const totalPages = Math.ceil(currentYearData.length / itemsPerPage);

      const paginatedData = currentYearData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );


        // Magazine/Newsletter Section
        const MagazineSection = () => (
        <div>
          <div className="newsletter-item-list">
            <div className="newsletter-list-header mobile-title">Title</div>
            <div className="newsletter-list-header">Attachment</div>

            {paginatedData.map((item) => (
        <Fragment key={item.id}>
          <div className="newsletter-item-title mobile-title">
            {item.title}
          </div>

          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="newsletter-item-link"
          >
            <span className="pdf-badge">PDF</span>
            <span className="pdf-link">View / Download</span>
          </a>
        </Fragment>
      ))}


          {paginatedData.length === 0 && (
            <p style={{ padding: "20px" }}>No newsletters found.</p>
          )}
        </div>

        {/* Pagination */}
        <div className="pagination-wrapper">
          <button
            className="pagination-btn pagination-next-btn"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Previous
          </button>

          <button className="pagination-btn active">
            {currentPage}
          </button>

          <button
            className="pagination-btn pagination-last-btn"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Next
          </button>
        </div>
      </div>
    );


        // Photo Gallery Section
   const PhotoGallerySection = () => {
  const photos = galleryImages.filter(item => item.type === 'photo');
  const visiblePhotos = getVisibleItems(photos);

  return (
    <div>
      <div className="gallery-section-header">Our Activity</div>

      <div className="gallery-grid">
        {visiblePhotos.map(item => (
          <div key={item.id} className="gallery-item">
            <img src={item.imageUrl} alt={item.title} />
            <div className="gallery-item-caption">{item.title}</div>
          </div>
        ))}
      </div>

      {/* ✅ SEE MORE — MUST BE INSIDE RETURN */}
      {photos.length > 6 && (
        <div className="see-more-wrapper">
          <button
            className="see-more-link"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'See Less' : 'See More'}
          </button>
        </div>
      )}
    </div>
  );
};



        // Videos Gallery Section
    const VideosGallerySection = () => {
  const videos = galleryImages.filter(item => item.type === 'video');
  const visibleVideos = getVisibleItems(videos);

  return (
    <div>
          <div className="gallery-section-header">Our Activity</div>

          <div className="gallery-grid">
            {visibleVideos.map(item => (
              <div
                key={item.id}
                className="gallery-item gallery-item-with-play"
                onClick={() => window.open(item.videoUrl, '_blank')}
                style={{ cursor: 'pointer' }}
              >
                <img src={item.imageUrl} alt={item.title} />
                <div className="play-overlay">▶</div>
                <div className="gallery-item-caption">{item.title}</div>
              </div>
            ))}
          </div>

         {videos.length > 6 && (
        <div className="see-more-wrapper">
          <button
            className="see-more-link"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'See Less' : 'See More'}
          </button>
        </div>
      )}
    </div>
  );
};


        // Awards Section
  const AwardsSection = () => {
  const awards = galleryImages.filter(item => item.type === 'award');
  const visibleAwards = getVisibleItems(awards);

  return (
    <div>
          <div className="gallery-section-header">Our Awards</div>

          <div className="gallery-grid">
            {visibleAwards.map(item => (
              <div key={item.id} className="gallery-item">
                <img src={item.imageUrl} alt={item.title} />
                <div className="gallery-item-caption">{item.title}</div>
              </div>
            ))}
          </div>

        {awards.length > 6 && (
        <div className="see-more-wrapper">
          <button
            className="see-more-link"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'See Less' : 'See More'}
          </button>
        </div>
      )}
    </div>
  );
};
        return (
            <Fragment>
                <Helmet>
                    <link rel="preconnect" href="https://fonts.googleapis.com" />
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                    <link
                        href="https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700;800&display=swap"
                        rel="stylesheet"
                    />
                </Helmet>
                <div className="jjfv2">
                    <HeaderV2 />
                    <AboutHero
                        eyebrow="Our Bulletin"
                        title="Newsletters"
                        crumbs={[{ label: 'Home', to: '/' }, { label: 'Newsletters' }]}
                    />
                </div>
                <main className="page_content">
                    <div className="container newsletter-wrap">
                        <div className="newsletter-main-card">
                            
                            {/* Mobile Sidebar */}
                            <div className="d-lg-none m-4">
                                <div className="mobile-menu-container" >
                                    <div className='mobile-menu-item-container'>
                                            <button className={`mobile-menu-item ${activeTab === 'magazine' ? 'active' : ''}`} onClick={() => setActiveTab('magazine')} >
                                                Magazine
                                            </button>
                                    </div>
                                    
                                    <div className='mobile-menu-item-container'>
                                        <button className={`mobile-menu-item ${activeTab === 'photo' ? 'active' : ''}`} onClick={() => setActiveTab('photo')} >
                                            Photo
                                        </button>
                                    </div>

                                    <div className='mobile-menu-item-container'>
                                        <button className={`mobile-menu-item ${activeTab === 'video' ? 'active' : ''}`} onClick={() => setActiveTab('video')} >
                                            Videos
                                        </button>
                                    </div>

                                    <div className='mobile-menu-item-container'>
                                        <button className={`mobile-menu-item ${activeTab === 'awards' ? 'active' : ''}`} onClick={() => setActiveTab('awards')} >
                                            Awards
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-4">
                                {/* Sidebar - Desktop Only */}
                                <div className="col-lg-3 d-none d-lg-block">
                                    <Sidebar />
                                </div>

                                {/* Main Content */}
                                <div className="col-lg-9 col-12">
                                    <div className="newsletter-content">
                                        <div className="section-title">
                                            {activeTab === 'magazine' && 'Newsletter'}
                                            {activeTab === 'photo' && 'Photo Gallery'}
                                            {activeTab === 'video' && 'Videos Gallery'}
                                            {activeTab === 'awards' && 'Awards'}
                                        </div>

                                        <FilterBar showFYears={activeTab === 'magazine' && 'Newsletter'} />

                                        {/* Content Sections */}
                                        <div className='newsletter-main-section'>
                                            {activeTab === 'magazine' && <MagazineSection />}
                                            {activeTab === 'photo' && <PhotoGallerySection />}
                                            {activeTab === 'video' && <VideosGallerySection />}
                                            {activeTab === 'awards' && <AwardsSection />}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>
                <div className="jjfv2">
                    <FooterV2 />
                </div>
            </Fragment>
        );
    }